//请自行添加语言资源
const waybill = {
  fetchNo: '抓取批次',
  vbeln: '交货',
  tknum: '装运编号',
  shtyp: '装运类型',
  tplst: '运输计划点',
  bezei: '描述',
  ernam: '创建对象的人员名称',
  erdat: '记录的创建日期',
  erzet: '输入时间',
  aedat: '更改日期',
  aezet: '上一次作修改的时间',
  vsbed: '装运条件',
  vtext: '描述',
  route: '路线',
  name2: '路径的描述',
  signi: '容器 ID',
  dpreg: '登记的计划日期',
  dplbg: '装载开始计划日期',
  dplen: '装载终止计划日期',
  dpabf: '关于装运完成的计划日期',
  zxzjh: '是否限制交货日期',
  dtdis: '计划终止的日期',
  dareg: '登记的实际日期',
  dalbg: '装载开始的当前日期',
  dalen: '装载终止的实际日期',
  tdlnr: '转运代理的编号',
  name1: '名称',
  addressD: '发货地址',
  name33D: '发货联系人',
  bezei1: '收货方',
  address: '收货地址',
  name33: '收货联系人',
  telNumber: '收货方联系电话',
  zyyzd1: '预留字段1',
  zyyzd2: '预留字段2',
  zyyzd3: '预留字段3',
  zyyzd4: '预留字段4',
  zyyzd5: '预留字段5',
  dealTime: '处理时间',
  dealStatus: '处理状态',
  dealCount: '处理次数',
  dealResult: '处理结果',
  createTime: '创建时间',
  creator: '创建者',
  updateTime: '修改时间',
  updater: '修改者',
  detail: {
    tknum: '装运编号',
    tpnum: '装运项目',
    vbeln: '交货',
    posnr: '交货单行项目',
    bstkd: '销售订单备注',
    zfwfc: '扫描',
    matnr: '物料编码',
    maktx: '物料描述',
    charg: '批次',
    hsdat: '生产日期',
    vfdat: '货架到期日',
    werks: '工厂',
    name1: '工厂描述',
    lgort: '库位',
    lgobe: '库位描述',
    umrez: '规格',
    divLgmng: '箱数',
    modLgmng: '零数',
    lgmng: '总支数',
    brgew: '总重量(吨)',
    volum: '体积(M3)',
    zyyzd1: '预留字段1',
    zyyzd2: '预留字段2',
    zyyzd3: '预留字段3',
    zyyzd4: '预留字段4',
    zyyzd5: '预留字段5',
  },
  msg: {}
};
export default waybill



// WEBPACK FOOTER //
// ./src/page/log/waybill/lang/waybill.zh.js